import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import { useCallback } from "react";
import { getDD_RUM } from "../datadog/rum";
import { getGlobalProperty } from "../globals/getGlobalProperty";
// checking if window is undefined is for NextJS server not to read global properties
var routeContextStore = createContextStore({
    productArea: // eslint-disable-next-line @faire-web/no-restricted-globals
    "object" === "undefined" ? "PRODUCT_AREA_UNKNOWN" : getGlobalProperty("routeProductArea"),
    pod: // eslint-disable-next-line @faire-web/no-restricted-globals
    "object" === "undefined" ? "FAIRE_POD_UNKNOWN" : getGlobalProperty("routePod"),
    pillar: // eslint-disable-next-line @faire-web/no-restricted-globals
    "object" === "undefined" ? "FAIRE_PILLAR_UNKNOWN" : getGlobalProperty("routePillar"),
    templatedPath: // eslint-disable-next-line @faire-web/no-restricted-globals
    "object" === "undefined" ? "FAIRE_TEMPLATED_PATH_UNKNOWN" : getGlobalProperty("templatedPath")
});
export var useRouteContext = routeContextStore.useStore;
export var RouteContextProvider = routeContextStore.Provider;
export var useSetRouteContext = function() {
    var _routeContextStore_useStore = _sliced_to_array(routeContextStore.useStore([]), 2), setRouteStore = _routeContextStore_useStore[1];
    return useCallback(function(routeMetadata) {
        var _getDD_RUM_getRumGlobalContext, _getDD_RUM, _getDD_RUM_addRumGlobalContext, _getDD_RUM1;
        var normalizedProps = normalizeProps(routeMetadata);
        setRouteStore(normalizedProps);
        var _getDD_RUM_getRumGlobalContext1;
        // Also update DD RUM context to capture new route metadata
        var existingRumContext = (_getDD_RUM_getRumGlobalContext1 = (_getDD_RUM = getDD_RUM()) === null || _getDD_RUM === void 0 ? void 0 : (_getDD_RUM_getRumGlobalContext = _getDD_RUM.getRumGlobalContext) === null || _getDD_RUM_getRumGlobalContext === void 0 ? void 0 : _getDD_RUM_getRumGlobalContext.call(_getDD_RUM)) !== null && _getDD_RUM_getRumGlobalContext1 !== void 0 ? _getDD_RUM_getRumGlobalContext1 : {};
        var _existingRumContext_faire;
        var faire = (_existingRumContext_faire = existingRumContext.faire) !== null && _existingRumContext_faire !== void 0 ? _existingRumContext_faire : {};
        faire.product_area = normalizedProps.productArea;
        faire.pod = normalizedProps.pod;
        faire.pillar = normalizedProps.pillar;
        (_getDD_RUM1 = getDD_RUM()) === null || _getDD_RUM1 === void 0 ? void 0 : (_getDD_RUM_addRumGlobalContext = _getDD_RUM1.addRumGlobalContext) === null || _getDD_RUM_addRumGlobalContext === void 0 ? void 0 : _getDD_RUM_addRumGlobalContext.call(_getDD_RUM1, "faire", faire);
        if (normalizedProps.templatedPath) {
            var _getDD_RUM_addRumGlobalContext1, _getDD_RUM2;
            (_getDD_RUM2 = getDD_RUM()) === null || _getDD_RUM2 === void 0 ? void 0 : (_getDD_RUM_addRumGlobalContext1 = _getDD_RUM2.addRumGlobalContext) === null || _getDD_RUM_addRumGlobalContext1 === void 0 ? void 0 : _getDD_RUM_addRumGlobalContext1.call(_getDD_RUM2, "templatedPath", normalizedProps.templatedPath);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            getWindowOrThrow().templatedPath = normalizedProps.templatedPath;
        }
    }, [
        setRouteStore
    ]);
};
var normalizeProps = function(props) {
    return {
        productArea: props.productArea === "PRODUCT_AREA_UNKNOWN" ? undefined : props.productArea,
        pod: props.pod === "FAIRE_POD_UNKNOWN" ? undefined : props.pod,
        pillar: props.pillar === "FAIRE_PILLAR_UNKNOWN" ? undefined : props.pillar,
        templatedPath: props.templatedPath
    };
};
